import dClient from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {setCurrentTag} from "../tag/slice";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";


export const getTagById = (id, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `tag/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setCurrentTag(res.data));
    // return callback && callback(res.data.product.attributes);
};

export const createTag = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `tag`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const editTag = (id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'put',
        `tag/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
};

export const deleteTag = ({ tag_id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `tag/${tag_id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res,dispatch)) return '';
    return callback && callback(res);
};